// Segmentos que el Admin VL puede elegir en una promo, leídos de retail-promotions.
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
    resolvePromotionsAvailability,
    shouldRetryPromotionsQuery,
    type PromotionsAvailability,
} from '../lib/promotionsFormat';
import { pickableSegments } from '../lib/segmentAvailability';
import { isPromotionsConfigured, promotionsClient } from './promotions.client';
import type { SalePromotionSegment } from './promotionsContract';
import { PROMOTIONS_QUERY_KEY } from './usePromotions';

export interface SalePromotionSegmentsState {
    /** Sin el catch-all del tenant. */
    segments: SalePromotionSegment[];
    state: PromotionsAvailability;
}

/** `enabled` lo prende el formulario abierto; cerrado no pide nada. */
export function useSalePromotionSegments(enabled: boolean): SalePromotionSegmentsState {
    const configured = isPromotionsConfigured();
    const query = useQuery({
        queryKey: [...PROMOTIONS_QUERY_KEY, 'segments'],
        queryFn: () => promotionsClient.listSalePromotionSegments(),
        enabled: enabled && configured,
        retry: shouldRetryPromotionsQuery,
        staleTime: 300_000,
    });
    const segments = useMemo(
        () => pickableSegments(query.data?.segments ?? []),
        [query.data?.segments],
    );
    const state = resolvePromotionsAvailability({
        configured,
        isSuccess: query.isSuccess,
        error: query.error,
    });
    return { segments, state };
}
